import ContentsTypes from "@shared/enums/contentsTypes";
import ContactTemplate from "@project/templates/contact/ContactTemplate";
import customTypes from "@project/enums/contentsCustomTypes.enum";
export default {
    key: "CONTACT",
    label: "Nous contacter",
    shortDescription: "Une question, un projet ou une candidature ? Écrivez-nous, notre équipe vous répondra avec attention.",
    templateImage: "/template-contact.png",
    Component: ContactTemplate,
    initialContents: [
        {
            key: "contactForm",
            type: customTypes.CONTACT_FORM,
            value: "",
        },
        {
            key: "dynamicPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
        },
        {
            key: "addressTitle",
            type: ContentsTypes.EDITABLE_INPUT,
            value: "Plan d’accès",
        },
        {
            key: "dynamicLocationPart",
            type: ContentsTypes.DYNAMIC,
            value: "",
            children: [
                {
                    children: [
                        {
                            children: [],
                            type: "INPUT",
                            value: "49.403386",
                            key: "latitude",
                        },
                        {
                            children: [],
                            type: "INPUT",
                            value: "1.114309",
                            key: "longitude",
                        },
                        {
                            children: [],
                            type: "SLIDER",
                            value: "10",
                            key: "initialZoom",
                        },
                        {
                            children: [],
                            type: "INPUT",
                            value: "DocaposteAgility",
                            key: "name",
                        },
                        {
                            children: [],
                            type: "INPUT",
                            value: "1&2 bis, Rue Antoine Laurent de Lavoisier",
                            key: "address",
                        },
                        {
                            children: [],
                            type: "INPUT",
                            value: "Sotteville-lès-Rouen",
                            key: "city",
                        },
                        {
                            children: [],
                            type: "INPUT",
                            value: "76300",
                            key: "postalCode",
                        },
                    ],
                    type: customTypes.GEOGRAPHIC_MAP,
                    key: "dynamicElements",
                    value: "",
                },
                {
                    children: [],
                    type: ContentsTypes.TEXT,
                    value: "%3Cp%3E%3Cstrong%3EAdresse%20postale%3C%2Fstrong%3E%3C%2Fp%3E%3Cp%3E1%20et%202%20bis%20Rue%20Antoine%20Laurent%20Lavoisier%3Cbr%3E76300%20Sotteville-l%C3%A9s-Rouen%3C%2Fp%3E",
                    key: "dynamicElements",
                },
                {
                    children: [
                        {
                            children: [],
                            type: ContentsTypes.SELECT,
                            key: "justifyContent",
                            value: "center",
                        },
                        {
                            children: [],
                            type: ContentsTypes.SLIDER,
                            value: "12",
                            key: "spacing",
                        },
                        {
                            children: [],
                            type: ContentsTypes.CHECKBOX,
                            key: "columnOnMobile",
                            value: "true",
                        },
                    ],
                    type: ContentsTypes.ROW,
                    value: "",
                    key: "dynamicElements",
                },
            ],
        },
    ],
};
